import type { TNotification } from '@/constants/notifications';
import type { TRawMutationMeta } from '@/lib/notify';

import { ERROR_FALLBACK } from '@/constants/errors';
import { NOTIFICATIONS } from '@/constants/notifications';
import { readNotifyMeta } from '@/lib/notify';
import { resolveErrorCopy } from '@/utils/errorCopy';
import { toFailureKey } from '@/utils/errorReason';

const EMPTY_NOTIFICATION: TNotification = {};

const toNotification = (meta: TRawMutationMeta): TNotification => {
  const { notify } = readNotifyMeta(meta);

  if (!notify) {
    return EMPTY_NOTIFICATION;
  }

  return NOTIFICATIONS[notify];
};

const toSuccessToast = (meta: TRawMutationMeta): string | undefined => toNotification(meta).success;

const toErrorToast = (meta: TRawMutationMeta, error: Error): string | undefined => {
  const notification = toNotification(meta);
  const isErrorHandled = readNotifyMeta(meta).isErrorHandled ?? notification.isErrorHandled ?? false;

  if (isErrorHandled) {
    return undefined;
  }

  const reasonCopy = notification.errorCopy?.[toFailureKey(error) ?? ''];

  return notification.error ?? reasonCopy ?? notification.errorCopy?.[error.message] ?? resolveErrorCopy(error.message) ?? ERROR_FALLBACK;
};

export {
  toErrorToast,
  toSuccessToast,
};
